export default "__VITE_ASSET__64bbeb2b__"